/* =================== MENU FULL =================== */
jQuery(document).ready(function ($) {
  /*DESCE E SOBE BARRA DE BUSCA*/
  $(".segura-menu-mobile-pesquisa").on("click", function () {
    $(".segura-menu-mobile-barra-pesquisa").slideToggle();
  });
  /*DESCE E SOBE BARRA DE BUSCA*/

  if (!isMobileX(1119)) {
    const $menu = $(".fdx-menu");
    const $busca = $(".header-busca");

    // Fixa o menu ao rolar a página
    $(window).on(
      "scroll",
      debounce(function () {
        toggleMenuFixed();
      }, 10)
    );
    function toggleMenuFixed() {
      let scrollTop = $(window).scrollTop();
      if (scrollTop > 150) {
        $menu.addClass("fixed");
        $busca.addClass("fixed");
      } else {
        $menu.removeClass("fixed");
        $busca.removeClass("fixed");
      }
    }
    toggleMenuFixed();

    // Movimenta a linha inferior com base no link ativo
    const $indicator = $('<span class="fdx-menu-indicator"></span>');
    $menu.find(".container").prepend($indicator);
    posMenuIndicator($menu.find(".fdx-menu-1-level > li.active"));
    $menu
      .find(".fdx-menu-1-level > li:not(.busca-toggle)")
      .mouseenter(function () {
        posMenuIndicator($(this));
      });
    $menu
      .find(".fdx-menu-1-level > li:not(.busca-toggle)")
      .mouseleave(function () {
        posMenuIndicator($menu.find(".fdx-menu-1-level > li.active"));
      });
    function posMenuIndicator($ele) {
      const left = $ele.offset().left;
      const width = $ele.outerWidth();
      $indicator.stop().animate(
        {
          left: left,
          width: width,
        },
        400
      );
    }
  }
});
